import React from 'react';
import { Box, Collapse, Typography, makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import { FINANCE } from '../../theme/financeTheme';
import { FinanceNavItem } from './FinanceNavItem';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: FINANCE.navBg,
    borderRight: `1px solid ${FINANCE.line}`,
  },
  brand: {
    padding: '18px 16px 14px',
    borderBottom: `1px solid ${FINANCE.line}`,
    background: `linear-gradient(180deg, ${FINANCE.primaryLight} 0%, ${FINANCE.surface} 100%)`,
  },
  brandMark: {
    fontSize: '0.625rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: FINANCE.primary,
  },
  brandTitle: {
    fontSize: '1.0625rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: FINANCE.text,
    marginTop: 2,
  },
  section: {
    padding: '12px 8px 8px',
  },
  sectionLabel: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: FINANCE.muted,
    padding: '0 14px 6px',
  },
});

export const FinanceNav = () => {
  const classes = useStyles();
  const location = useLocation();

  // The Sales Forecasting group is "inside" whenever the forecast view is open.
  const inForecast =
    new URLSearchParams(location.search).get('view') === 'forecast';

  // Keep the dropdown open when the user is inside it; otherwise let them
  // toggle it manually.
  const [expanded, setExpanded] = React.useState(inForecast);
  React.useEffect(() => {
    if (inForecast) setExpanded(true);
  }, [inForecast]);

  return (
    <Box className={classes.root}>
      <Box className={classes.brand}>
        <Typography className={classes.brandMark}>Finance</Typography>
        <Typography className={classes.brandTitle}>Reporting</Typography>
      </Box>

      <Box className={classes.section}>
        <Typography className={classes.sectionLabel}>Apps</Typography>
        <FinanceNavItem
          icon={AccountBalanceIcon}
          text="P&L & Allocations"
          to="finance/reporting"
          matchPaths={['finance/reporting', 'finance/reporting?view=pl']}
        />
        <FinanceNavItem
          icon={TrendingUpIcon}
          text="Sales Forecasting"
          to="finance/reporting?view=forecast"
          matchPaths={['finance/reporting?view=forecast']}
          expandable
          expanded={expanded}
          onToggleExpand={() => setExpanded(prev => !prev)}
        />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <FinanceNavItem
            text="Leader mapping"
            to="finance/reporting?view=forecast&tab=leaders"
            isSubItem
          />
          <FinanceNavItem
            text="Client mapping"
            to="finance/reporting?view=forecast&tab=mapping"
            isSubItem
          />
          <FinanceNavItem
            text="Report generation"
            to="finance/reporting?view=forecast&tab=report"
            isSubItem
          />
        </Collapse>
      </Box>
    </Box>
  );
};
